import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const folder: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13-7.25v5.5q0 .719-.516 1.234A1.69 1.69 0 0 1 11.25 0h-9.5Q1.031 0 .516-.516A1.68 1.68 0 0 1 0-1.75v-7.5q0-.717.516-1.234A1.68 1.68 0 0 1 1.75-11h2.5q.717 0 1.234.516Q6-9.968 6-9.25V-9h5.25q.717 0 1.234.516c.344.343.516.757.516 1.234m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "13",
  }
};
